type PageDataContent = {
    regionName: string,
    name: string
}

type GenerateBreadcrumbsArgs = {
    store: ReturnType<typeof useRoutesStore>,
    localeRef: ReturnType<typeof useI18n>["locale"],
    getParentPath: ReturnType<typeof usePageUtils>["getParentPath"],
    route: ReturnType<typeof useRoute>,
    basePageEntry: { title?: string },
    pageData: { content?: PageDataContent }
}

export const generateRegionCountryBreadcrumbs = ({ store, localeRef, getParentPath, route, basePageEntry, pageData }: GenerateBreadcrumbsArgs): BreadcrumbType[] | null => {
    if (!pageData.content || !basePageEntry.title) return null

    const { getRouteByPath } = useRoutes(store.routes, localeRef)

    const regionSlug = getParentPath(route.path)
    const paymentMethodGuidesSlug = getParentPath(regionSlug)
    const paymentMethodGuidesRoute = getRouteByPath(paymentMethodGuidesSlug)
    if (!paymentMethodGuidesRoute) return null;

    const regionRoute = getRouteByPath(regionSlug)
    if (!regionRoute) return null

    const basePageBreadcrumb: BreadcrumbType = { title: basePageEntry.title, url: paymentMethodGuidesRoute.route }
    const regionBreadcrumb: BreadcrumbType = { title: pageData.content.regionName, url: regionRoute.route }
    const countryBreadcrumb: BreadcrumbType = { title: pageData.content.name }

    return [basePageBreadcrumb, regionBreadcrumb, countryBreadcrumb]
}